export default defineNuxtPlugin(function () {
  window.addEventListener('load', function () {
    var script = document.createElement('script');
    script.setAttribute('async', '');
    script.setAttribute('src', 'https://calendarx.imgsmail.ru/atc-button/latest/atc-button.js');
    document.head.appendChild(script);
  });
});